import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";

export default function POS() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/pos") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      }
      return null;
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <div className="w-full min-h-screen bg-white dark:!bg-navy-900">
      <main className="w-full min-h-screen">
        <div className="flex w-full min-h-screen">
          <div className="flex flex-col w-full min-h-screen px-0">
            <Routes>
              {getRoutes(routes)}
              <Route path="/" element={<Navigate to="/pos/pos" replace />} />
            </Routes>
          </div>
        </div>
      </main>
    </div>
  );
}
